export const eventsConstants = {
    GET_ALL_EVENTS_DATA_REQUEST: 'GET_ALL_EVENTS_DATA_REQUEST',
    GET_ALL_EVENTS_DATA_SUCCESS: 'GET_ALL_EVENTS_DATA_SUCCESS',
    GET_ALL_EVENTS_DATA_FAILURE: 'GET_ALL_EVENTS_DATA_FAILURE',
    
    GET_EVENT_DATA_REQUEST: 'GET_EVENT_DATA_REQUEST',
    GET_EVENT_DATA_SUCCESS: 'GET_EVENT_DATA_SUCCESS',
    GET_EVENT_DATA_FAILURE: 'GET_EVENT_DATA_FAILURE',

    UPDATE_EVENT_DATA_REQUEST: 'UPDATE_EVENT_DATA_REQUEST',
    UPDATE_EVENT_DATA_SUCCESS: 'UPDATE_EVENT_DATA_SUCCESS',
    UPDATE_EVENT_DATA_FAILURE: 'UPDATE_EVENT_DATA_FAILURE',

    SET_CURRENT_EVENT_ID: 'SET_CURRENT_EVENT_ID',
    UNSET_CURRENT_EVENT_ID: 'UNSET_CURRENT_EVENT_ID'    
}


// WEBPACK FOOTER //
// ./src/constants/events.js